import Vue from "vue";

const modulo_productos_compra = {
    strict: false,

    state: {
        productos_compra: [],
        metodos_pago: [],
        current: 0,
        page: 1,
    },

    getters: {
        getproductos_compra: (state) => state.productos_compra,
    },

    mutations: {
        get_productos_compra: (state, productos_compra) => {
            state.productos_compra = productos_compra;
            state.page = 2;
        },
        update_productos_compra: (state, productos_compra) => {
            state.productos_compra = state.productos_compra.concat(
                productos_compra.data
            );
            state.page = productos_compra.current_page + 1;
        },
        add_search: (state, productos_compra) => {
            state.productos_compra =
                state.productos_compra.concat(productos_compra);
        },
    },

    actions: {
        getProductosCompra: (context, vm) => {
            axios.get("api/get-productos-compra?amount=15&page=1").then(
                (res) => {
                    context.commit(
                        "get_productos_compra",
                        res.data.success.data
                    );
                },
                (res) => {}
            );
        },
        getProductosCompraWithId: (context, vm) => {
            axios.get(`api/get-productos-compra?amount=15&page=1`).then(
                (res) => {
                    context.commit(
                        "get_productos_compra",
                        res.data.success.data
                    );
                },
                (res) => {}
            );
        },
        getProductosCompraNext: (context, vm) => {
            axios
                .get(
                    `api/get-productos-compra?amount=15&page=${
                        context.state.page ?? 1
                    }`
                )
                .then(
                    (res) => {
                        context.commit(
                            "update_productos_compra",
                            res.data.success
                        );
                    },
                    (res) => {}
                );
        },
        searchProductosCompra: (context, vm) => {
            axios
                .get(
                    `api/get-productos-compra?amount=15&page=1${
                        vm ? `&search=${vm}` : ""
                    }`
                )
                .then(
                    (res) => {
                        context.commit(
                            "update_productos_compra",
                            res.data.success
                        );
                    },
                    (res) => {}
                );
        },
    },
};

export default modulo_productos_compra;
